import React, { Fragment, useState, useContext, useEffect } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import ModalPop from "components/sales/modal/modal";
import DropDownInput from "components/sales/Input/dropDownInput/dropDownInput";
import localization from "assets/localization/localization";
import Images from "assets/images/imageData";
import { Link } from "react-router-dom";
import { BaseUrl } from "contexts/baseUrl/baseUrl";
import { toast } from "react-toastify";
import { useRef } from "react";
import "./assign_location.css";

const AssignLocation = ({
  showAssignLocationPopup,
  onClosePopup = () => {},
  locationAssignUserId,
  citiesDropdownResponse,
  zonesDropdownResponse,
  zonesDropdownData,
  assignLocationsToUser,
  areasDropdownData,
  areasDropdownResponse = [],
  approvalCase = false,
  setLocationData = {},
}) => {
  const [location, setLocation] = useState({
    city_id: "",
    zone_id: [],
    area_id: [],
    zoneOptions: [],
  });
  const [isLoading, setIsLoading] = useState(false);
  const [successModal, setSuccessModal] = useState(false);
  const [areaResponseModal, setAreaResponseModal] = useState(false);
  const { baseUrl } = useContext(BaseUrl);
  const [totalAreas, setTotalAreas] = useState(null);
  const debounceRef = useRef(null);
  const [zonesAreasData, setZonesAreasData] = useState({});
  const [selectedAreas, setSelectedAreas] = useState({});
  const [isAreaConfirmed, setIsAreaConfirmed] = useState(false);

  const handleCityChange = async (cityId) => {
    setIsLoading(true);
    await zonesDropdownData(cityId);

    const zoneOptions = zonesDropdownResponse?.response?.data || [];

    setLocation({
      ...location,
      city_id: cityId,
      zone_id: [],
      area_id: [],
      zoneOptions,
    });
    setIsAreaConfirmed(false);
    setIsLoading(false);
  };

  const handleZoneChange = (zoneIds) => {
    setIsLoading(true);

    const selectedZoneIds = Array.isArray(zoneIds)
      ? zoneIds.map((z) => z.id)
      : zoneIds?.id
      ? [zoneIds.id]
      : [];

    setLocation((prev) => ({ ...prev, zone_id: selectedZoneIds }));

    if (debounceRef.current) clearTimeout(debounceRef.current);

    debounceRef.current = setTimeout(async () => {
      const res = await areasDropdownData(selectedZoneIds);
      const total = res?.data?.total_areas || null;
      setTotalAreas(total);

      setZonesAreasData(res?.data?.zones || {});
      setIsAreaConfirmed(false);
      setIsLoading(false);
    }, 500);
  };

  const handleSubmit = async () => {
    const payload = {
      location_data: { [location.city_id]: selectedAreas },
      user_id: locationAssignUserId,
    };
    onClosePopup();
    setIsLoading(true);
    const res = await assignLocationsToUser(payload);

    if (res?.status == 200) {
      setSuccessModal(true);
    } else {
      toast.error(res?.message);
    }

    setIsLoading(false);
  };

  const handleLocationDataConfirm = () => {
    const payload = {
      location_data: { [location.city_id]: selectedAreas },
      user_id: locationAssignUserId,
    };
    onClosePopup();
    setLocationData(payload);
  };

  useEffect(() => {
    if (Object.keys(zonesAreasData).length > 0) {
      const initial = {};
      Object.entries(zonesAreasData).forEach(([zoneId, zone]) => {
        initial[zoneId] = zone.areas.map((a) => a.id);
      });
      setSelectedAreas(initial);
    }
  }, [zonesAreasData]);

  const handleSuccessModalHide = () => {
    setSuccessModal(false);
  };

  useEffect(() => {
    if (showAssignLocationPopup) {
      setLocation({
        city_id: "",
        zone_id: [],
        area_id: [],
        zoneOptions: [],
      });
      setTotalAreas(null);
      setIsAreaConfirmed(false);
    }
  }, [showAssignLocationPopup]);

  const handleAreaResponseModal = () => {
    setAreaResponseModal(true);
  };

  const handleAreaResponseModalHide = () => {
    setAreaResponseModal(false);
  };

  const handleAreaSelect = (zoneId, areaId, checked) => {
    setSelectedAreas((prev) => {
      const existing = prev[zoneId] || [];

      return {
        ...prev,
        [zoneId]: checked
          ? [...existing, areaId]
          : existing.filter((id) => id !== areaId),
      };
    });
  };

  return (
    <>
      <ModalPop
        title={"Assign Location"}
        show={showAssignLocationPopup}
        handleModalHide={onClosePopup}
      >
        <Fragment>
          <div className="row">
            {/* City Dropdown */}
            <div className="col-md-5">
              <DropDownInput
                data={citiesDropdownResponse?.response?.data}
                label={localization.city}
                required
                errorMsg={localization.isRequired}
                isStarRequired={true}
                getIdValue={(val) => {
                  if (location.city_id !== val.id) handleCityChange(val.id);
                }}
              />
            </div>

            {/* Zone Dropdown (Multi-Select) */}
            <div className="col-md-5">
              <DropDownInput
                data={zonesDropdownResponse?.response?.data}
                label={localization.zone}
                required
                errorMsg={localization.required}
                isStarRequired={true}
                multipule
                getIdValue={(val) => {
                  handleZoneChange(val);
                }}
              />
            </div>

            {totalAreas !== null && (
              <div className="col-md-2">
                <button
                  className="btn btn-info btn-sm"
                  onClick={handleAreaResponseModal}
                >
                  {totalAreas} Select Areas
                </button>
              </div>
            )}
          </div>
          {approvalCase
            ? (totalAreas === null || isAreaConfirmed) && (
                <div
                  className="d-flex mt-3"
                  style={{ justifyContent: "flex-start" }}
                >
                  <button
                    type="button"
                    className="btn btn-success"
                    onClick={handleLocationDataConfirm}
                    disabled={
                      isLoading ||
                      !location.city_id ||
                      location.zone_id.length === 0
                    }
                  >
                    Submit
                  </button>
                </div>
              )
            : (totalAreas === null || isAreaConfirmed) && (
                <div
                  className="d-flex mt-3"
                  style={{ justifyContent: "flex-start" }}
                >
                  <button
                    type="button"
                    className="btn btn-success"
                    onClick={handleSubmit}
                    disabled={
                      isLoading ||
                      !location.city_id ||
                      location.zone_id.length === 0
                    }
                  >
                    Submit
                  </button>
                </div>
              )}
        </Fragment>
      </ModalPop>

      <ModalPop
        title={localization.success}
        show={successModal}
        handleModalHide={handleSuccessModalHide}
        keyboard
        backdrop
      >
        <div className="text-center">
          <div className="success">
            <img src={Images?.tick} alt="" />
          </div>
          <h5>{"Location Assigned Successfully"}</h5>
          <button
            className="btn btn-primary mb-4"
            onClick={() => window.location.reload()}
          >
            {"Close"} <img src={Images?.ArrowRight} alt="" />
          </button>
        </div>
      </ModalPop>

      <ModalPop
        title={"Areas Details"}
        show={areaResponseModal}
        handleModalHide={handleAreaResponseModalHide}
        keyboard
        backdrop
      >
        {Object.entries(zonesAreasData || {}).map(([zoneId, zone]) => (
          <div className="panel-card">
            <div className="panel-heading">{zone.zone_name}</div>
            <div className="panel-body">
              <table className="area-table">
                <thead>
                  <tr>
                    <th style={{ width: "60px" }}>Select</th>
                    <th style={{ textAlign: "center" }}>Area Name</th>
                  </tr>
                </thead>

                <tbody>
                  {zone.areas?.map((area) => (
                    <tr key={area.id}>
                      <td>
                        <input
                          type="checkbox"
                          checked={
                            selectedAreas[zoneId]?.includes(area.id) || false
                          }
                          onChange={(e) =>
                            handleAreaSelect(zoneId, area.id, e.target.checked)
                          }
                        />
                      </td>
                      <td className="area-name">{area.name}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        ))}
        <button
          className="btn btn-primary mt-3"
          onClick={() => {
            setIsAreaConfirmed(true);
            handleAreaResponseModalHide();
          }}
        >
          Confirm
        </button>
      </ModalPop>
    </>
  );
};

AssignLocation.propTypes = {
  citiesDropdownResponse: PropTypes.any,
  zonesDropdownResponse: PropTypes.any,
  zonesDropdownData: PropTypes.func,
  showAssignLocationPopup: PropTypes.bool,
  onClosePopup: PropTypes.func,
};

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

export default connect(null, mapDispatchToProps)(AssignLocation);
